import { Flex } from '@/common/components';
import { createComponent, IntrinsicProps } from '@/common/util/templateHelpers';

import style from './index.module.scss';

interface ProductFeatureProps extends IntrinsicProps {
  small?: boolean
}

const classStates = [
  'small'
];

export default createComponent<ProductFeatureProps>('ProductFeature', 
  { style, classStates }, 
  function ProductFeature ({ className, slots }) {
    return (
      <Flex gap0 container directionColumn alignCenter className={className}>
        <Flex className='ProductFeature__Graphic --padMd0__l --padMd0__r'>
          <Flex alignCenter justifyCenter>
            {slots.graphic}
          </Flex>
        </Flex>
        <Flex>
          <h3>{slots.title}</h3>
        </Flex>
        <Flex justifyCenter>
          <p>{slots.description}</p>
        </Flex>
      </Flex>
    );
  });
